(function () {
  "use strict";

  var module = angular.module("uwAgenda.agenda");

  // controller for one agenda
  module.controller("AgendaPerPeriodController", [
    "$rootScope",
    "$scope",
    "$uibModal",
    "$state",
    "AgendaService",
    "DownloadService",
    "ExportFormat",
    "AgendaDay",
    "AgendaWeek",
    "AgendaBroadcast",
    "DateService",
    "DayschemeService",
    "WebsocketRegisterType",
    "WebsocketService",
    "AgendaOverviewService",
    'AgendaItemResizeObserverService',
    AgendaPerPeriodControllerFn,
  ]);

  function AgendaPerPeriodControllerFn(
    $rootScope,
    $scope,
    $uibModal,
    $state,
    AgendaService,
    DownloadService,
    ExportFormat,
    AgendaDay,
    AgendaWeek,
    AgendaBroadcast,
    DateService,
    DayschemeService,
    WebsocketRegisterType,
    WebsocketService,
    AgendaOverviewService,
    AgendaItemResizeObserverService
  ) {
    const vm = this;

    // current service (day or week) (selected shared agenda)
    vm.service = {}; // vm for data of agenda

    // collapsed
    vm.collapsed = false;

    // allowed to add extra-day/ block ?
    vm.newExtraDayAllowed = false;

    activate();

    vm.isWeekDayVisible = function (day, times) {
      const date = moment(day);
      const isWeekday = date.day() !== 6 && date.day() !== 0;
      return isWeekday || times.length > 0;
    };

    /* Block agenda items */
    vm.block = function () {
      // show modal
      const modalInstance = $uibModal.open({
        backdrop: true,
        keyboard: true,
        animation: true,
        templateUrl: "/app/agenda/templates/agenda-block-modal.template.html",
        controller: "AgendaBlockModalController",
        controllerAs: "vm",
        size: "md",
        resolve: {
          agendaId: function () {
            return vm.sharedAgenda.id;
          },
        },
      });

      // when modal is closed
      modalInstance.result.then(
        function () {},
        function () {
          // dismissed
        }
      );
    };

    /* export agenda */
    vm.export = function (documentType) {
      let exportFormat = ExportFormat.PDF.value;
      if (documentType === 'word')
      {
        exportFormat = ExportFormat.WORD.value
      }
      DownloadService.exportAgendaPeriod(
          exportFormat,
        vm.sharedAgenda.owner.id,
        vm.period === "day",
        vm.service.data.date
      ).then(function (response) {
        DownloadService.openReport(exportFormat, response, "agenda");
      });
    };

    // collapse
    vm.collapse = function () {
      vm.collapsed = !vm.collapsed;
      // collapse parts
      vm.service.collapse(vm.collapsed);
    }; // collapse

    // refresh agendas
    function refresh(agendaIds) {
      // refresh only related agenda
      if (
        agendaIds !== null &&
        agendaIds.some(function (id) {
          return id === vm.sharedAgenda.id;
        })
      ) {
        // block ui
        $scope.$broadcast(AgendaBroadcast.BlockUnblock, vm.sharedAgenda.id);

        // load times per period
        load();
      } //if
    } // refresh

    // listen for websocket events
    function listen() {
      // Websocket Listen
      var ws = WebsocketService.register(
        WebsocketRegisterType.Agenda,
        function (jObject) {
          let dayOk = false;
          // Day Or WeekView
          if (vm.period === "day") {
            // refresh if (right Agenda AND Date) Or (No Agenda -> And Date Is Set)
            dayOk = DateService.isSameDay(
              jObject.data.appointmentDate,
              DateService.data.date
            );
          } // if
          else if (vm.period === "week") {
            // refresh if (right Agenda AND Date In Week) Or (No Agenda -> And Date Is Set)
            dayOk = DateService.isInWeek(jObject.data.appointmentDate);
          } // else if

          // refresh if (right Agenda AND Date In Week) Or (No Agenda -> And Date Is Set)
          if (jObject.data.fK_Agenda === vm.sharedAgenda.id && dayOk) {
            refresh([jObject.data.fK_Agenda]);
          } else if (jObject.data.fK_Agenda === undefined && dayOk) {
            refresh([vm.sharedAgenda.id]);
          }
        }
      );

      // on destroy
      $scope.$on("$destroy", function () {
        if (ws) {
          WebsocketService.unregister(ws.id);
        }
        AgendaOverviewService.data.weekView = false;
      });
    }

    // load agenda times per period
    function load() {
      // clear
      vm.service.clear();

      const agenda = vm.service.data.sharedAgenda;

      // depending on Period -> select agenda - data
      if (vm.period === "day") {
        // load new items
        AgendaService.day(
          vm.service.data.sharedAgenda.id,
          vm.service.data.date
        ).then(function (times) {

          // filter out "No appointment possible" label if set in the agenda settings
          if (!agenda.showNoAppointmentPossibleLabels) {
            times = times.filter(function(time) {
              return !time.isNoApppointmentPossibleLabel || time.isAppointment;
            });
          }          

          // init agenda day service with times
          vm.service.init(times);

          // assign agenda to each time
          times.forEach(function (time) {
            time.agenda = agenda;
          });

          // load DayScheme for Description
          DayschemeService.getByDate(
            vm.service.data.sharedAgenda.owner.id,
            vm.service.data.date
          ).then(function (result) {
            vm.service.data.description = result.description;
          });

          setTimeout(() => AgendaItemResizeObserverService.observe());

          // unblock ui
          $scope.$broadcast(AgendaBroadcast.BlockUnblock, vm.sharedAgenda.id);
        });
      } // if
      else if (vm.period === "week") {
        AgendaService.week(
          vm.service.data.sharedAgenda.id,
          vm.service.data.date
        ).then(function (result) {
          
          for(const key of Object.keys(result)) {
            let times = result[key];

            // assign agenda to each time
            times.forEach(function(time) {
              time.agenda = agenda;
            });

            // filter out "No appointment possible" label if set in the agenda settings
            if (!agenda.showNoAppointmentPossibleLabels) {            
              times = times.filter(function(time) {
                return !time.isNoApppointmentPossibleLabel || time.isAppointment;
              });
            }
            
            result[key] = times;
          }          
          
          // init week-agenda with day and their time items
          vm.service.init(result);

          // number of weeks if week-view
          let number = 0;
          angular.forEach(vm.service.data.week, function (day) {
            if (day.length > 0) {
              number++;
            }
          });
          if (vm.period === "week") {
            vm.daysInWeek = number;
          }

          // unblock ui
          $scope.$broadcast(AgendaBroadcast.BlockUnblock, vm.sharedAgenda.id);
        });
      } // else
    } // load

    // activation work
    function activate() {
      // current selected date
      const date = DateService.data.date;
      // selected agenda-service for view -> (day-service or week-service)
      if (vm.period === "day") {
        AgendaOverviewService.data.weekView = false;
        vm.service = new AgendaDay();

        // current selected date of agenda
        vm.service.data.date = date;
        vm.service.data.dateCaption = DateService.getDateCaption();
      } //if
      else if (vm.period === "week") {
        AgendaOverviewService.data.weekView = true;
        vm.service = new AgendaWeek();
        // current selected week of agenda
        vm.service.data.date = date;
        vm.service.data.weekNumber = DateService.data.info.week;
      } // else if

      // add current shared agenda
      vm.service.data.sharedAgenda = vm.sharedAgenda;

      // allowed to add new extra-day ?
      vm.newExtraDayAllowed =
          $rootScope.isRingfoon || $rootScope.isMainuser || $rootScope.isSubuser;

      // load agenda time items per period
      load();

      // listen to events
      listen();
    } // activate
  }
})();
